<template>
    <div>
        <div class="actions">
            <div class="action action--wide">
                <transition name="fade" mode="out-in" :duration="1000">
                    <button key="current" v-if="currentWorkday" @click="endWorkday" class="action-button action-button--workday js-btn-workday">
                        {{ $t('labels.end_workday') }}
                    </button>

                    <button v-else @click="startWorkday" class="action-button action-button--workday">
                        {{ $t('labels.start_workday') }}
                    </button>
                </transition>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <cancel-button></cancel-button>
            </div>

            <div class="col-md-6 text-right">
                <button class="btn btn-secondary btn--xl" @click="synchronise" :disabled="!online" v-if="isManager">{{ $t('labels.synchronise') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import CancelButton from "../components/app/CancelButton";

    export default {
        components: {CancelButton},

        methods: {
            startWorkday () {
                this.$store.dispatch('startWorkday');
                this.$store.commit('setChecked');
            },

            endWorkday () {
                this.$store.dispatch('endWorkday');
                this.$store.commit('setChecked');
            },

            synchronise () {
                window.events.$emit('syncLocalToRemote');
            }
        },

        computed: {
            online () {
                return this.$store.state.online
            },

            currentDevice () {
                return this.$store.getters.currentDevice
            },

            currentEmployee () {
                return this.$store.getters.currentEmployee
            },

            isManager () {
                if (this.$store.getters.currentLocation) {
                    const self = this
                    return this.$store.getters.currentLocation.managers.find((manager) => {
                        return manager.id === self.currentEmployee.id
                    })
                }
                return false
            },

            currentWorkday () {
                return this.$store.getters.currentWorkday
            }
        },

        mounted () {
            if (this.currentEmployee === null || this.currentEmployee === undefined) {
                this.$router.push('pin')
            }
        }
    }
</script>

